export default __webpack_public_path__ + "static/media/eng.30ca5d9c.png";